import React from 'react';
import './App.css';
// import Sidebar from './components/sidebar';
import Navbar from './components/navbar';

function App() {
  return (
    <div>
      {/* <Sidebar /> */}
      <Navbar />
    </div>
  );
}

export default App;
